import {
  Button,
  Flex,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text,
} from "@chakra-ui/react";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import TitleFlex from "../defaultComponents/titleFlex";
import VendasDigitadasApi from "../../../../services/vendasDigitadasApi";
import ModalSendEmailRequest from "./modalSendEmailRequest";
import { useSetRecoilState, useRecoilState } from "recoil";
import { customColors } from "../../../../atoms/customColors";

export default function ModalRevisãoVendaDigitada({
  isOpen,
  setIsOpen,
  item,
}: any) {
  const finalRef = React.useRef(null);
  const onClose = () => {
    setIsOpen(false);
  };
  const navigate = useNavigate();

  const colors = useRecoilState(customColors)[0];

  const [openModalSendEmail, setOpenModalSendEmail] = useState(false);
  const [token, setToken] = useState("");
  const [salvando, setSalvando] = useState(false);

  async function postVendaDigitada() {
    // Trava de reentrada: sem isto, dois cliques enquanto a requisicao esta em voo criam
    // duas vendas — e cada uma gera um link de pagamento valido.
    if (salvando) return;

    try {
      setSalvando(true);
      const response = await VendasDigitadasApi.postVendaDigitada(item);
      setToken(response.token);
      // onClose();
      setOpenModalSendEmail(true);
    } catch (error) {
      console.log("error", error);
      toast.error(`Não foi possível registrar a venda! Erro: ${error}`);
      // so libera no erro: no sucesso o modal de envio assume a tela, e reabilitar o
      // botao atras dele seria convite para confirmar a mesma venda de novo
      setSalvando(false);
    }
  }

  function SumTotal() {
    if (item.itens.length) {
      const soma = item.itens.length
        ? item.itens
            .map((i: any) => {
              return i.valorItem * i.quantidade;
            })
            .reduce((a: any, b: any) => a + b, 0)
        : 0;
      return soma.toLocaleString("pt-BR", {
        style: "currency",
        currency: "BRL",
      });
    }
  } 
  console.log("item", item); 

  // console.log("soma dos itens", SumTotal());

  return (
    <>
      <Modal
        finalFocusRef={finalRef}
        isOpen={isOpen}
        onClose={onClose}
        size={"xl"}
      >
        <ModalOverlay backdropFilter="blur(10px)" />
        <ModalContent>
          <ModalHeader></ModalHeader>
          <ModalBody>
            <TitleFlex item={"Informações do Pagador"} />
            <Flex px={4} flexDir={"column"}>
              <Text fontSize={"14px"} my={2}>
                {item && `Nome : ${item.nomePagador}`}
              </Text>
              <Text fontSize={"14px"} my={2}>
                {item && `E-mail : ${item.emailPagador}`}
              </Text>
              <Text fontSize={"14px"} my={2}>
                {item && `CPF do Pagador : ${item.cpfPagador}`}
              </Text>
            </Flex>
            <TitleFlex item={"Informações de Pagamento"} />
            <Flex px={4} flexDir={"column"}>
              <Text fontSize={"14px"} my={1}>
                {item &&
                  `Pagamento por PIX : ${
                    item.permitirPix === false ? "Não" : "Sim"
                  }`}
              </Text>
              <Text fontSize={"14px"} my={1}>
                {item && `Parcelamento Minimo : ${item.parcelaMinima}`}
              </Text>
              <Text fontSize={"14px"} my={1}>
                {item && `Parcelamento Máximo : ${item.parcelaMaxima}`}
              </Text>
            </Flex>
            <TitleFlex item={"Itens da Venda"} />

            {item && item.itens.length ? (
              item.itens.map((i: any, index: any) => {
                return (
                  <Flex
                    flexDir={"row"}
                    px={6}
                    key={index}
                    my={2}
                    justifyContent={"space-between"}
                  >
                    <Flex flexDir={"column"} w={"80%"}>
                      <Text fontWeight={"bold"}>
                        {i.codigo != ""
                          ? `${i.codigo} - ${i.descricao}`
                          : i.descricao}
                      </Text>
                      <Text>{`Quantidade : ${i.quantidade}`}</Text>
                      <Text>{`Valor do item : ${i.valorItem.toLocaleString(
                        "pt-BR",
                        {
                          style: "currency",
                          currency: "BRL",
                        }
                      )}`}</Text>
                    </Flex>
                    <Flex alignItems={"center"}>
                      <Text
                        fontWeight={"bold"}
                        fontSize={"16px"}
                        color={colors.GRAY_DARK}
                      >
                        {(i.quantidade * i.valorItem).toLocaleString("pt-BR", {
                          style: "currency",
                          currency: "BRL",
                        })}
                      </Text>
                    </Flex>
                  </Flex>
                );
              })
            ) : (
              <Flex px={6}>
                <Text>Ainda não foram cadastrados itens para esta venda</Text>
              </Flex>
            )}
            {item && item.itens.length ? (
              <>
                <TitleFlex item={"Total da Venda"} />
                <Flex justifyContent={"flex-end"} pr={6}>
                  <Text
                    fontWeight={"bold"}
                    fontSize={"18px"}
                    color={colors.VARIANT}
                  >
                    {item.itens.length ? SumTotal() : "R$ 0,00"}
                  </Text>
                </Flex>
              </>
            ) : (
              <></>
            )}

            <TitleFlex item={"Mensagem"} />
            <Flex px={4}>
              <Text fontSize={"14px"}>
                {item.mensagem
                  ? item.mensagem
                  : `Não há mensagens para esta venda!`}
              </Text>
            </Flex>
          </ModalBody>
          <ModalFooter justifyContent={"space-evenly"}>
            <Button
              background={colors.GRAY}
              color={"white"}
              mr={3}
              onClick={onClose}
            >
              Fechar
            </Button>
            <Button
              background={colors.GREENMONEDD}
              color={"white"}
              mr={3}
              isDisabled={
                item.nomePagador != "" &&
                item.emailPagador != "" &&
                item.cpfPagador != "" &&
                item.itens.length > 0 &&
                item.idCliente > 0
                  ? false
                  : true
              }
              isLoading={salvando}
              loadingText={"Registrando..."}
              onClick={() => {
                postVendaDigitada();
              }}
            >
              Confirmar
            </Button>
          </ModalFooter>
        </ModalContent>
        <ModalSendEmailRequest
          isOpen={openModalSendEmail}
          setIsOpen={setOpenModalSendEmail}
          token={token}
          permitirPix={item.permitirPix}
        />
      </Modal>
    </>
  );
}
